<div class="tophead fixed-top">
  <app-header></app-header>
</div>
<div class="browserview" id="vxbody">
  <router-outlet></router-outlet>
</div>
<div class="bottomfoot">
  <app-footer></app-footer>
</div>
